// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bam_a","InstagramEmbed__mask":"bam_b bhe_bi bhe_bo bhe_wx"};